var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_16331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.83 85.1699C182.83 98.6199 178.84 111.77 171.37 122.95C163.9 134.13 153.28 142.85 140.85 148C128.42 153.15 114.75 154.49 101.56 151.87C88.37 149.25 76.25 142.77 66.74 133.26C57.23 123.75 50.75 111.63 48.13 98.4399C45.51 85.2499 46.85 71.5799 52 59.1499C57.15 46.7199 65.86 36.0999 77.05 28.6299C88.23 21.1599 101.38 17.1699 114.83 17.1699C132.86 17.1799 150.15 24.3499 162.9 37.0999C175.65 49.8499 182.82 67.1399 182.83 85.1699Z",
    fill: "#E54839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.68 154.79C58.31 157.89 58.01 161.11 56.82 164.03C55.63 166.96 53.59 169.46 50.97 171.24C48.35 173.01 45.26 173.96 42.1 173.98C38.94 173.99 35.84 173.07 33.2 171.33C30.56 169.59 28.49 167.1 27.27 164.19C26.04 161.27 25.71 158.06 26.31 154.96C26.91 151.85 28.42 148.99 30.64 146.75C32.87 144.5 35.71 142.96 38.81 142.33C40.87 141.9 42.99 141.88 45.06 142.27C47.13 142.67 49.1 143.46 50.85 144.62C52.61 145.78 54.12 147.27 55.29 149.02C56.46 150.77 57.28 152.72 57.69 154.79H57.68Z",
    fill: "#001419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.05 85.1698L136.83 72.3898C139.38 69.8398 139.38 65.7198 136.83 63.1698C134.28 60.6198 130.16 60.6198 127.61 63.1698L114.83 75.9498L102.05 63.1698C99.51 60.6198 95.38 60.6198 92.83 63.1698C90.28 65.7198 90.28 69.8398 92.83 72.3898L105.61 85.1698L92.83 97.9498C90.28 100.5 90.28 104.62 92.83 107.17C94.1 108.44 95.77 109.08 97.44 109.08C99.11 109.08 100.78 108.44 102.05 107.17L114.83 94.3898L127.61 107.17C128.88 108.44 130.55 109.08 132.22 109.08C133.89 109.08 135.56 108.44 136.83 107.17C139.38 104.62 139.38 100.5 136.83 97.9498L124.05 85.1698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83 85.1699C182.83 98.6199 178.84 111.77 171.37 122.95C163.9 134.13 153.28 142.85 140.85 148C128.42 153.15 114.75 154.49 101.56 151.87C88.37 149.25 76.25 142.77 66.74 133.26C57.23 123.75 50.75 111.63 48.13 98.4399C45.51 85.2499 46.85 71.5799 52 59.1499C57.15 46.7199 65.86 36.0999 77.05 28.6299C88.23 21.1599 101.38 17.1699 114.83 17.1699C132.86 17.1799 150.15 24.3499 162.9 37.0999C175.65 49.8499 182.82 67.1399 182.83 85.1699Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3501 41.56C56.9101 30.75 71.4101 23.61 87.0301 21.06C102.64 18.49 118.67 20.62 133.08 27.16C147.49 33.7 159.63 44.37 167.98 57.82C176.33 71.26 180.5 86.88 179.97 102.69C179.44 118.5 174.23 133.8 165 146.66C155.77 159.52 142.94 169.34 128.13 174.9C113.32 180.46 97.1901 181.5 81.7801 177.9C66.3701 174.3 52.3801 166.21 41.5701 154.65C27.0801 139.14 19.3501 118.53 20.0601 97.32C20.7701 76.12 29.8701 56.07 45.3601 41.57L45.3501 41.56Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 180C177.31 180 180 177.31 180 174C180 170.69 177.31 168 174 168C170.69 168 168 170.69 168 174C168 177.31 170.69 180 174 180Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.05 85.1698L136.83 72.3898C139.38 69.8398 139.38 65.7198 136.83 63.1698C134.28 60.6198 130.16 60.6198 127.61 63.1698L114.83 75.9498L102.05 63.1698C99.51 60.6198 95.38 60.6198 92.83 63.1698C90.28 65.7198 90.28 69.8398 92.83 72.3898L105.61 85.1698L92.83 97.9498C90.28 100.5 90.28 104.62 92.83 107.17C94.1 108.44 95.77 109.08 97.44 109.08C99.11 109.08 100.78 108.44 102.05 107.17L114.83 94.3898L127.61 107.17C128.88 108.44 130.55 109.08 132.22 109.08C133.89 109.08 135.56 108.44 136.83 107.17C139.38 104.62 139.38 100.5 136.83 97.9498L124.05 85.1698Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5801 20.6499L27.8101 27.7199L33.1701 26.7699L31.4001 33.8399",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_16331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error-image.fad32bcadc9630ba80e3024f95bbb128.svg";
export { ForwardRef as ReactComponent };